export const sanitizeID = (url) => {
  const array = url.split("/")
  return parseInt(array[array.length - 1])
}
